import { useMemo } from "react"
import LicenseCoverageCard from "@/v2-backoffice-client/license/coverage/LicenseCoverageCard"
import { useLicenseCoverageQuery } from "@/v2-backoffice-client/license/coverage/license.coverage.query"
import { getLicenseCoverageWindow } from "@/v2-backoffice-client/license/coverage/license.coverage.utils"

export type CustomerLicenseCoverageNoticeProps = {
  customerId: number
}

// The coverage issues of this customer's licenses, on the panel where the
// licenses are worked: the same cards as Licensing → Coverage, only the
// ones with something to fix, with the bridge and the Fenerum link right
// there. Renders nothing when billing, invoicing and access agree, so the
// caller mounts it unconditionally. This is what was missing on 2 Nov 2026,
// when Atlas Eiendom's slot read "Scheduled · from 01.09.2026" and three
// operators could not tell that the account was invoiced for a period no
// subscription covered.
function CustomerLicenseCoverageNotice(
  props: CustomerLicenseCoverageNoticeProps,
) {
  const { customerId } = props
  const { data } = useLicenseCoverageQuery({ variables: { customerId } })
  const window = useMemo(() => getLicenseCoverageWindow(), [])

  const withIssues = (data?.getLicenseCoverage ?? []).filter(
    (coverage) => coverage.IssueSeverity > 0,
  )
  if (withIssues.length === 0) return null

  return (
    <section
      className="flex flex-col gap-2"
      role="status"
      data-feature-code="UI_BackofficeCustomer_LicenseCoverage_Notice"
    >
      {withIssues.map((coverage, index) => (
        <LicenseCoverageCard
          key={coverage.LicenseId}
          coverage={coverage}
          window={window}
          showAxis={index === 0}
          onCustomerPanel
        />
      ))}
    </section>
  )
}

export default CustomerLicenseCoverageNotice
